import React from 'react';

const RequiredFieldIndicator = ({ children }) => {
    return <span className="required required--inline">{children}</span>;
};

export default RequiredFieldIndicator;
